import React, { useEffect, useState } from "react";
import im from "../Media/packages.png";
import MainImage from "../Components/MainImage";
import {
  Container,
  Stack,
  Typography,
  useMediaQuery,
  Box,
} from "@mui/material";
import SmallBtns from "../Components/SmallBtns";
import OurGoal from "../Components/OurGoal";
import kk from "../Media/1.png";
import kk2 from "../Media/2.png";
import kk3 from "../Media/4 (1).png";
import kk4 from "../Media/5 (1).png";
import kk5 from "../Media/3 (2).png";
import AboutUs from "../Components/AboutUs";
import ServicesCard from "../Components/ServicesCard";
import Questions from "../Components/Questions";
import db from "../DbFile.json";
import pic from "../Media/Mashawiri shortcut.png";
import { useTranslation } from "react-i18next";

export default function Donation({ setTheState }) {
  const [el, setEl] = useState(db.first_array);
  const [Qs, setQs] = useState(db.Packages_Q);
  useEffect(() => {
    setTheState(false);
  }, []);
  const { t } = useTranslation();
  return (
    <>
      <MainImage
        image={im}
        txt1={"Use Our Packages"}
        txt2={"To Save Money"}
        btxt={"Book your ride"}
      />
      <br />
      <br />
      <Container>
        <Stack sx={{ justifyContent: "center", alignItems: "center" }}>
          <Typography
            sx={{ color: "#1D2877", fontWeight: "bold", fontSize: "30px" }}
          >
            {t("Pay")}
          </Typography>
        </Stack>
        <br />
        <Stack
          direction={"row"}
          gap={4}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <SmallBtns txt={"Pay"} name={"PayAnyOne"} />
          <SmallBtns txt={"Packages"} name={"Packages"} />
        </Stack>
        <br />
        <br />
        <Stack sx={{ justifyContent: "center", alignItems: "center" }}>
          <img
            alt="img96589658"
            src={pic}
            style={{ height: "100px", width: "120px", marginBottom: "10px" }}
          />
          <Typography sx={{ fontSize: "20px", color: "#1D2877" }}>
            {t(
              "For a comfortable and enjoyable trip for you,there are packages in Mashawiri. Check out the available packages"
            )}
          </Typography>
        </Stack>
      </Container>
      <OurGoal
        im={kk}
        caption={"Roaming classic package within the city"}
        btn={"Book your ride"}
        txt={
          "You can use the package to get a special trip within the city with all the details included in the package"
        }
      />
      <AboutUs
        caption={"Roaming package within the city for 7 passengers"}
        txt={
          "You can use the package to get a special trip within the city with number of passengers up to seven with all the details included in the package"
        }
        pic={kk2}
        btn={"Book your ride"}
      />
      <OurGoal
        im={kk3}
        caption={"A van package for roaming within the city"}
        btn={"Book your ride"}
        txt={
          "You can use the package to travel in van within the city with a good price with duration up to 6 hours"
        }
      />
      <AboutUs
        caption={"Tourist trip package outside the city"}
        txt={
          "You can use the package to get a special offer when you have a trip outside the city"
        }
        pic={kk4}
        btn={"Book your ride"}
      />
      <OurGoal
        im={kk5}
        caption={"A VIP package for roaming within the city"}
        btn={"Book your ride"}
        txt={
          "You can use the package to get a special trip within the city with a vip car to To ensure your comfort"
        }
      />

      <Box
        sx={{
          marginTop: "5%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ fontWeight: "bold", fontSize: "40px", color: "#1D2877" }}
        >
          {t("Explore more with Mashawiri")}
        </Typography>
        {el && <ServicesCard el={el.filter((el) => el.id !== 4)} />}
      </Box>
      <Questions questions={Qs} />
    </>
  );
}
